var _path, _path2, _circle, _circle2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSadface(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.889,
    height: 27,
    title: "Sad Face",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C45455",
    d: "M21.264 13.471a24.5327 24.5327 0 00.639 5.558c.211.907.467 1.79.771 2.652.305.86.646 1.684 1.031 2.47.131.271.197.52.197.742 0 .226-.061.408-.184.549-.121.14-.266.262-.436.365l-1.938 1.121c-.682-1.047-1.266-2.113-1.752-3.198-.486-1.087-.885-2.188-1.193-3.305a23.9945 23.9945 0 01-.68-3.417c-.145-1.16-.217-2.34-.217-3.538 0-1.197.072-2.375.217-3.536.145-1.16.371-2.298.68-3.417s.707-2.219 1.193-3.305S20.664 1.057 21.346 0l1.938 1.123c.16.104.301.225.422.365.121.141.184.318.184.534 0 .102-.018.215-.049.336-.033.122-.088.258-.162.407-.395.777-.74 1.598-1.039 2.463a24.767 24.767 0 00-.758 2.667c-.205.911-.359 1.836-.463 2.777-.105.941-.155 1.874-.155 2.799z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#C45455",
    d: "M7.187 11.71h7.578v3.507H7.187z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#C45455",
    cx: 2.399,
    cy: 8.672,
    r: 2.399
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#C45455",
    cx: 2.399,
    cy: 18.256,
    r: 2.399
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadface);
export default __webpack_public_path__ + "static/media/sadface.e2f5e45f.svg";
export { ForwardRef as ReactComponent };